import React, { Component } from 'react';

import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import NumericInput from 'react-numeric-input';
import WhseDropDown from '../WhseDropDown/WhseDropDown';

import 'react-dropdown/style.css';

import './styles.css';

import * as FileSaver from 'file-saver';


class MOQTable extends Component {

    constructor(props) {
        super(props)  
        this.state = {
            data: [],
            handleTableData: [],
            isFirstTimeSearch: true,
            lastDataTable: [],
            show: false,
            currentPage: 1,
            todosPerPage: 7,
            pageNumbers: [],
            selectedRow: -1,
            currentPagination: 1,
            paginationLimit: 7,
        };   
        this.cancelArray = [];
    }

    exportToCSV = async (csvData) => {

        const XLSX = await import("xlsx");

        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, 'MOQ-file' + fileExtension);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.filterItem && nextProps.type == "item")  return this.filterItem(nextProps.filterItem);
        if(nextProps.filterVendor && nextProps.type == "vendor")   return this.filterVendor(nextProps.filterVendor);
        if(nextProps.responseData.length !== 0 && this.state.data.length === 0) {
            return this.formatDataResponse(nextProps);  
        } 
        if(this.state.data.length !== nextProps.responseData.length) {
            return this.formatDataResponse(nextProps);  
        }
        if(this.state.data.length === nextProps.responseData.length && (!nextProps.filterItem && !nextProps.filterVendor)) {
            return this.formatDataResponse(nextProps);  
        }
    }

    formatDataResponse = (dataMoq) => {
        dataMoq.responseData.map((data, index) => {
            data.changeSku = false;
            data.changeVendorNumber = false;
            data.changeItemVendor = false;
            data.changeItemVendorMOQ = false;
            data.changeItemVendorMoqPerPO = false;
            data.changeWhse = false;
            data.checked = false;
            data.masterIndex = index;
        });       
        let pages = [];
        for (let i = 1; i <= Math.ceil(dataMoq.responseData.length / this.state.todosPerPage); i++) {
            pages.push(i);
        }
        this.setState({pageNumbers: pages});
        this.setState({data: dataMoq.responseData, show: true})        
    }


    sendMoq = (item) => {
        this.props.itemSend(item);
    }

    sendDeleteMoq = (item) => {
        this.props.itemDelete(item);
    }

    filterItem = (item) => {
        if(this.state.isFirstTimeSearch === true) {
            const data  = JSON.parse(JSON.stringify(this.state.data));
            this.setState({handleTableData: data});
        } 
        if(item === '') {
            let pages = [];
            for (let i = 1; i <= Math.ceil(this.state.handleTableData.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            this.setState({data: this.state.handleTableData,  pageNumbers: pages})        
        } else {
            let result = this.filteredTable(item);
            let pages = [];
            for (let i = 1; i <= Math.ceil(result.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            this.setState({data: result, pageNumbers: pages});
            if(result.length !== 0) this.setState({lastDataTable: result})
            this.state.isFirstTimeSearch = false;
        }     
    }

    filterVendor = (vendor) => {
        if(this.state.isFirstTimeSearch === true) {
            const data  = JSON.parse(JSON.stringify(this.state.data));
            this.setState({handleTableData: data});
        } 
        if(vendor === '') {
            let pages = [];
            for (let i = 1; i <= Math.ceil(this.state.handleTableData.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            this.setState({data: this.state.handleTableData, pageNumbers: pages})        
        } else {
            let result = this.filteredTableVendor(vendor);
            let pages = [];
            for (let i = 1; i <= Math.ceil(result.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            this.setState({data: result, pageNumbers: pages});
            if(result.length !== 0) this.setState({lastDataTable: result})
            this.state.isFirstTimeSearch = false;
        }  
    }

    filteredTable = function (search) {
        if(this.state.data !== undefined && this.state.data.length > 0) {
            let filtered = this.state.data.filter(item => String(item.sku).startsWith(search)); 
            return filtered;
        } else {
            const backupData = this.state.lastDataTable
            return backupData;
        }   
    }

    filteredTableVendor = function (search) {
        if(this.state.data !== undefined && this.state.data.length > 0) {
            let filtered = this.state.data.filter(item => String(item.vendorNumber).startsWith(search)); 
            return filtered;
        } else {
            const backupData = this.state.lastDataTable
            return backupData;
        }   
    }

    handleSkuChange = (e, data) => {
        const value = e.target.value;
        data.sku = value;
        data.changeSku = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleVendorNumberChange = (e, data) => {
        const value = e.target.value;
        data.vendorNumber = value;
        data.changeVendorNumber = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleWhseChange = (e, data) => {
        const value = e.target.value;
        data.whse = value;
        data.changeWhse = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleItemVendorChange = (e, data) => {
        const value = e;
        data.itemVendorMoq = value;
        data.changeItemVendor = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleItemVendorDcChange = (e, data) => {
        const value = e;
        data.itemVendorDcMoq = value;
        data.changeItemVendorMOQ = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleItemVendorPerPoChange = (e, data) => {
        const value = e;
        data.itemVendorMoqPerPO = value;
        data.changeItemVendorMoqPerPO = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleClick = (number) => {
        const pageNumber = number;
        this.setState({
          currentPage: pageNumber
        });
    }

    onCheckboxChange = (data, index) => {
        if(data.checked == false) {
            data.index = this.cancelArray.length == 0? 0 : this.cancelArray.length;
            data.checked = true;
            this.cancelArray.push(data)
            
        } else {
            data.checked = false;
            const indexArray = this.cancelArray.findIndex(obj => obj.index == data.index);
            this.cancelArray.splice(indexArray, 1);
        }
        this.sendDeleteMoq(this.cancelArray);
        this.setState({data: this.state.data});
    }

    onCheckboxSelectAllChange(event) {
        if(event.target.checked === true) {
            const allArray = this.state.data;
            allArray.map(obj => {
                obj.checked = true;
            });
            this.cancelArray = allArray;
        } else {
            const allArray = this.state.data;
            allArray.map(obj => {
                obj.checked = false;
            });
            this.cancelArray = [];
        }
        this.sendDeleteMoq(this.cancelArray);
        this.setState({data: this.state.data});        
    }

    onCancelChange = () => {
        const cancelArray = this.cancelArray.map(data => {
            if(data.cancel === 'N') {
                data.cancel = 'Y';    
            } else {
                data.cancel = 'N';
            }    
            return data;   
        });
        this.setState({data: this.state.data});
    }

    onExportToExcel = (data) => {
        let csvData;
        if(this.cancelArray.length > 0) {
            csvData = JSON.parse(JSON.stringify(this.cancelArray))
        } else if(data != null){
            csvData = JSON.parse(JSON.stringify(data));
        } else {
            csvData = JSON.parse(JSON.stringify(this.state.data));
        }

        var arrayData = [];
        var dataOrder = {};
        csvData.map(data => {
            dataOrder = {
                'Cancel': data.cancel,
                'Item': data.sku,
                'Item Desc': data.itemDescription,
                'Part': data.partNumber,
                'Whse': data.whse,
                'Vendor Number': data.vendorNumber,
                'Vendor Name': data.vendorName,
                'Item Vndr MOQ': data.itemVendorMoq,
                'Last Mod MOQ': data.itemVendorMoqLastModified,
                'Item Vndr Mult': data.itemVendorDcMoq,
                'Last Mod Vndr Mult': data.itemVendorDcMoqLastModified,
                'Item Vndr Per PO': data.itemVendorMoqPerPO,
                'Last Mod Vndr Per PO': data.itemVendorMoqPerPOLastModified,
            }
            arrayData.push(dataOrder);
        });

        this.exportToCSV(arrayData);
    }

    onDeleteData = () => {
        this.cancelArray = [];
    }

    handleClickPagination = (number) => {
        if(this.state.pageNumbers.length > 0) {
            if(typeof(number) === 'number') {
                const pageNumber = this.state.currentPagination + number;
                const limitPagination = Math.ceil(this.state.pageNumbers.length / this.state.paginationLimit);
                if(pageNumber > 0 && pageNumber <= limitPagination) {
                    this.setState({
                        currentPagination: pageNumber
                    });
                }
            } else {
                if(number === 'first') {
                    this.setState({
                        currentPagination: 1
                    });
                } else {
                    const limitPagination = Math.ceil(this.state.pageNumbers.length / this.state.paginationLimit);
                    this.setState({
                        currentPagination: limitPagination
                    });
    
                }
            }   
        }
    }

    render() {

        const { currentPage, todosPerPage } = this.state;

        // Logic for displaying current todos
        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        const currentTodos = this.state.data.slice(indexOfFirstTodo, indexOfLastTodo);

        //Pagination logic

        const { currentPagination, paginationLimit } = this.state;

        const indexOfLastPagination = currentPagination * paginationLimit;
        const indexOfFirstPagination = indexOfLastPagination - paginationLimit;
        const currentPaginationList = this.state.pageNumbers.slice(indexOfFirstPagination, indexOfLastPagination);      
        
        return(
            <div className="table-responsive">
                <table className="table table-sm table-striped table-bordered ">
                    <thead>
                        <tr>
                            <th className="text-center" rowSpan="2" colSpan="1">Select<br/><input type="checkbox" onClick={this.onCheckboxSelectAllChange.bind(this)}/></th>
                            <th className="text-center" rowSpan="2" colSpan="1">Cancel</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Item</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Item <br/>Desc</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Part</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Whse</th>
                            <th className="text-center" rowSpan="1" colSpan="2">Vendor</th>
                            <th className="text-center" rowSpan="1" colSpan="2">Item Vendor MOQ</th>
                            <th className="text-center" rowSpan="1" colSpan="2">Item Vendor Multiple</th>
                            <th className="text-center" rowSpan="1" colSpan="2">Item Vendor Per PO</th>
                        </tr>
                        <tr>
                            <th className="text-center">Number</th>
                            <th className="text-center">Name</th>
                            <th className="text-center">Units</th>
                            <th className="text-center">Last <br/>Modified</th>
                            <th className="text-center">Units</th>
                            <th className="text-center">Last <br/>Modified</th>
                            <th className="text-center">Units</th>
                            <th className="text-center">Last <br/>Modified</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data.length > 0 ? currentTodos.map((data,key) => {
                            return (
                            <tr key={key} className={data.cancel === 'Y' ? "row-moq-table tableSelected" : "row-moq-table" } >
                                <td className="text-center"><input type="checkbox" checked={data.checked} onChange={e => this.onCheckboxChange(data, key)}/></td>
                                <td className="text-center">{data.cancel === 'N'? 'NO': 'YES'}</td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="sku" value={data.sku} className="input-moqtable-sku" onChange={e => this.handleSkuChange(e, data)}/>{data.uploadedData? <i className="material-icons  cell-warning">warning</i> :data.changeSku === true? <i className="material-icons cell-warning">warning</i>: ''}</div></td>
                                <td><div className="cell-hidden-name" title={data.itemDescription}>{data.itemDescription}</div></td>
                                <td className="text-center part-number">{data.partNumber}</td>
                                <td className="text-center"><div className="alttable-cell-container"></div>
                                <WhseDropDown
                                    placeholder="Select an option"
                                    value={data.whse}
                                    options={[
                                        "10", "11", "20", "22", "30", "33", "52", "54", "55", "57", "58", "66", "69", "77", "86", "88", "99"
                                    ]}
                                    />
                                </td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="vendorNumber" value={data.vendorNumber} className="input-moqtable-vendorNumber" onChange={e => this.handleVendorNumberChange(e, data)}/>{data.uploadedData? <i className="material-icons  cell-warning">warning</i> :data.changeVendorNumber === true? <i className="material-icons cell-warning">warning</i>: ''}</div></td>
                                <td><div className="cell-hidden-name" title={data.vendorName}>{data.vendorName}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><NumericInput min={0} name="itemVendor" value={data.itemVendorMoq} className="input-moqtable-units" onChange={e => this.handleItemVendorChange(e, data)}/>{data.uploadedData? <i className="material-icons  cell-warning">warning</i> :data.changeItemVendor === true? <i className="material-icons cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center dateTableMoq">{data.itemVendorMoqLastModified}</td>
                                <td className="text-center "><div className="alttable-cell-container"><NumericInput min={0} name="itemVendorDc" value={data.itemVendorDcMoq} className="input-moqtable-units" onChange={e => this.handleItemVendorDcChange(e, data)}/>{data.uploadedData? <i className="material-icons  cell-warning">warning</i> :data.changeItemVendorMOQ === true? <i className="material-icons cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center dateTableMoq">{data.itemVendorDcMoqLastModified}</td>
                                <td className="text-center "><div className="alttable-cell-container"><NumericInput min={0} name="itemVendorPerPO" value={data.itemVendorMoqPerPO} className="input-moqtable-units" onChange={e => this.handleItemVendorPerPoChange(e, data)}/>{data.uploadedData ? <i className="material-icons cell-warning">warning</i> : data.changeItemVendorMoqPerPO === true ? <i className="material-icons cell-warning">warning</i> : ''}</div></td>
                                <td className="text-center dateTableMoq">{data.itemVendorMoqPerPOLastModified}</td>
                            </tr>
                            )
                        }) : <tr></tr>
                        }
                    </tbody>
                </table>
                <Pagination aria-label="Table navigation" className="pagination">
                    <PaginationItem>
                        <PaginationLink first  onClick={e => {this.handleClickPagination('first')}}/>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink previous onClick={e => {this.handleClickPagination(-1)}}/>
                    </PaginationItem>
                    {this.state.data.length > 0 ? currentPaginationList.map((data, key) => {
                        return (
                            <PaginationItem key={key}>
                                <PaginationLink onClick={e => this.handleClick(data)}>
                                    {data}
                                </PaginationLink>
                            </PaginationItem>
                        )
                    }): <div></div>
                    }
                    <PaginationItem>
                        <PaginationLink  next onClick={e => {this.handleClickPagination(1)}}/>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink last onClick={e => {this.handleClickPagination('last')}}/>
                    </PaginationItem>
                </Pagination>
                <p>Total Rows: {this.state.data.length}</p>     
            </div>
        );
    }
}

export default MOQTable;

